
/// Comprehensive UI translations
// Complete global UI translations
// Comprehensive UI translations
// Complete global UI translations
export const translations = {
  en: {
    // Common
    welcome: 'Welcome',
    loading: 'Loading...',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    logout: 'Logout',
    signingIn: 'Signing In...',
    signingUp: 'Creating Account...',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    name: 'Name',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    processing: 'Processing...',
    cancel: 'Cancel',

    // Auth
    welcomeBack: 'Welcome Back',
    enterCosmicRealm: 'Enter your cosmic realm',
    createAccount: 'Create Account',
    creatingAccount: 'Creating Account...',
    alreadyHaveAccount: 'Already have an account?',
    newToUniverse: "Don't have an account?",
    connectWithCosmicWisdom: 'Connect with cosmic wisdom',
    beginJourney: 'Begin Your Journey',
    loginFailed: 'Login failed',
    signupFailed: 'Signup failed',
    agreePrefix: 'I agree with',
    termsAndConditions: 'Terms and Conditions',
    agreeSuffix: '',
    privacy: 'Privacy',
    disclaimer: 'Disclaimer',
    contact: 'Contact',
    mustAcceptTerms: 'You must accept the Terms and Conditions',

    // Landing
    enterTheUniverse: 'Enter the Universe',
    askReceiveAlign: 'Ask. Receive. Align.',
    beginYourJourney: 'Begin Your Journey',
    cosmicWisdom: 'Receive mystical guidance and cosmic wisdom',
    experienceCosmicConnection: 'Experience Cosmic Connection',

    // Features
    mysticalWisdom: 'Mystical Wisdom',
    mysticalWisdomDesc: 'Receive personalized cosmic guidance crafted from ancient universal knowledge',
    dailyMessages: 'Daily Messages',
    dailyMessagesDesc: 'Start each day with profound insights from the cosmos',
    premiumAccess: 'Premium Access',
    premiumAccessDesc: 'Unlimited questions and deeper connection to universal consciousness',

    // Free plan / pricing
    freePlan: 'Free Plan',
    premiumPlan: 'Premium',
    premium: 'Premium',
    oneQuestionPerDay: '1 question per day',
    dailyCosmicMessages: 'Daily cosmic messages',
    questionHistoryFeature: 'Question history',
    chooseYourPath: 'Choose Your Path',
    startFree: 'Start Free',
    unlockPremium: 'Unlock Premium',
    activatePremiumAccess: 'Activate Premium Access',
    activatePremium: 'Activate Premium',
    upgradeToPremium: 'Upgrade to Premium',
    upgradeToPremiumForMore: 'Upgrade to Premium for unlimited questions',
    currentPlan: 'Plan',
    deepenConnection: 'Deepen your connection with the infinite',
    perMonth: '/month',
    monthly: 'Monthly',
    annual: 'Annual',
    bestValue: 'Best Value',
    month: 'month',
    year: 'year',
    billedMonthly: 'Billed monthly',
    save17Percent: 'Save ~17% vs monthly',
    equivalentTo: 'Equivalent to',
    premiumDescription: 'Deepen your connection with the infinite',
    annualBillingNote: 'Billed as one payment of $59.99/year',
    fullAccessTo: 'Full access to:',
    cancelAnytime: 'Cancel anytime.',
    noLongTermObligations: 'No long-term obligations.',
    popular: 'POPULAR',

    // Premium benefits
    unlimited: 'Unlimited',
    unlimitedQuestionsText: 'questions',
    deeperUniversalInsights: 'Deeper universal insights',
    enhancedIntuitiveGuidance: 'Enhanced intuitive guidance',
    personalQuestionArchive: 'Personal question archive',
    priorityResponseProcessing: 'Priority response processing',
    detailedDreamInterpretations: 'Detailed dream interpretations',
    personalizedTarot: 'Personalized tarot',
    energyReadingAlignment: 'Energy reading & alignment',
    completeHistory: 'Complete history',
    aiResponsePriority: 'AI response priority',

    // Dashboard / Universe
    todaysCosmicMessage: "Today's Cosmic Message",
    askTheUniverse: 'Ask the Universe',
    askUniverse: 'Ask Universe',
    enterQuestion: 'What guidance do you seek from the Universe?',
    consultingUniverse: 'Consulting the Universe...',
    theUniverseSpeaks: 'The Universe Speaks',
    questionHistory: 'Question History',
    viewQuestionHistory: 'View Question History',
    viewHistory: 'View',
    hideHistory: 'Hide',
    questionsRemaining: 'questions remaining',
    questionsRemainingToday: 'question remaining today',
    questionsRemainingTodayPlural: 'questions remaining today',
    unlimitedQuestions: 'Unlimited questions',
    dailyLimitReached: 'Daily limit reached. Upgrade to Premium for unlimited questions.',
    dailyLimitReachedWithCount:
      'You have reached your daily limit of {count} questions. Upgrade to Premium for unlimited access.',

    // Dream Portal
    dreamPortal: 'Dream Portal',
    unlockMysteries: 'Unlock the mysteries of your dreams',
    enterYourDreams: 'Enter Your Dreams',
    dreamsAreMessages:
      'Dreams are messages from your subconscious, whispers from the universe. Share your dreams and receive profound interpretations across symbolic, psychological, and energetic dimensions.',
    describeDream:
      'Describe your dream in as much detail as you remember... What did you see? What did you feel?',
    revealInterpretation: 'Reveal Interpretation',
    interpretingDream: 'Interpreting Your Dream...',
    dreamJournal: 'Dream Journal',
    symbolicMeaning: 'Symbolic Meaning',
    psychologicalMeaning: 'Psychological Meaning',
    energeticInterpretation: 'Energetic Interpretation',
    yourDream: 'Your Dream:',
    hideDreamJournal: 'Hide Dream Journal',
    viewDreamJournal: 'View Dream Journal',

    // Alignment
    dailyAlignment: 'Daily Alignment',
    calculatingAlignment: 'Calculating your cosmic alignment...',
    focusOn: 'Focus on',
    avoid: 'Avoid',
    alignmentHistory: 'alignment history',
    energyTheme: 'Energy Theme',

    // Tarot
    tarot: 'Tarot',
    tarotTitle: 'Draw Your Cards',
    tarotDescriptionFree:
      'Receive guidance from a single card draw. Upgrade to Premium for a full 3-card spread.',
    tarotDescriptionPremium:
      'Unveil the mysteries of Past, Present, and Future with your 3-card spread.',
    singleCardDraw: 'Single Card Draw',
    threeCardSpread: 'Three Card Spread',
    drawCards: 'Draw Cards',
    shuffling: 'Shuffling the deck...',
    tapToReveal: 'Tap to reveal',
    revealAll: 'Reveal All Cards',
    yourReading: 'Your Reading',
    past: 'Past',
    present: 'Present',
    future: 'Future',
    drawAgain: 'Draw Again',
    viewTarotHistory: 'View Tarot History',
    noTarotHistory: 'No tarot readings yet.',
    dailyTarotLimit:
      'You have already drawn your card today. Upgrade to Premium for unlimited draws.',
    tarotError: 'Failed to draw cards. Please try again.',
    unlockThreeCard: 'Unlock 3-Card Spreads',
    threeCardBenefit: 'Get deeper insights with Past, Present, and Future readings.',
    tarotCta: 'Draw your cards and unveil your destiny',
    premiumThreeCardActive: 'Full 3-card spread (Past/Present/Future) – active',

    // Love Portal
    lovePortal: 'Love Portal',
    lovePortalDesc: "Soulmates, twin flames, messages and love timing",
    lovePortalSubtitle: 'Enter the energy of love, destiny, soul connection, and emotional timing.',
    loveSoulmateTitle: 'Soulmate Reading',
    loveSoulmateDescription: 'Discover the energy of your soulmate and what is drawing them closer.',
    loveTwinFlameTitle: 'Twin Flame Reading',
    loveTwinFlameDescription: 'Explore separation, reunion energy, mirroring, and soul intensity.',
    loveMessageFromThemTitle: 'Message From Them',
    loveMessageFromThemDescription: 'Receive an intuitive love message from their energy.',
    loveTimingTitle: 'Love Timing',
    loveTimingDescription: 'See what emotional timing is unfolding in your love path.',
    loveYourName: 'Your name',
    loveYourNamePlaceholder: 'Your name',
    loveYourBirthDate: 'Your birth date',
    loveTheirName: 'Their name',
    loveTheirNamePlaceholder: 'Their name',
    loveTheirBirthDate: 'Their birth date',
    loveRelationshipContext: 'Relationship context',
    loveRelationshipContextPlaceholder: 'Tell Love Portal what is happening between you...',
    loveYourQuestion: 'Your question',
    loveQuestionPlaceholder: 'Example: Is this person my twin flame? Will we reconnect? What is their energy right now?',
    lovePortalLoading: 'Opening Love Portal...',
    enterLovePortal: 'Enter the Love Portal',
    loveMainMessage: 'Main Message',
    loveEnergy: 'Energy',
    loveObstacle: 'Obstacle',
    loveNextStep: 'Next Step',
    loveGuidance: 'Guidance',
    loveHistory: 'Love Portal History',
    loveLoadingHistory: 'Loading history...',
    loveNoHistory: 'No Love Portal readings yet.',
    lovePremiumTitle: 'Premium Love Portal',
    lovePremiumDescription: 'Unlock unlimited soulmate, twin flame, love timing, and message readings with Premium.',
    loveQuestionOrContextRequired: 'Please add a question or relationship context.',
    lovePortalFailed: 'Failed to open Love Portal.',
    loveCompatibility: 'Compatibility',
    lovePassion: 'Passion',
    loveCommunication: 'Communication',
    loveTimingScore: 'Timing',
    back: 'Back',

    // Share
    share: 'Share',
    copyText: 'Copy text',
    download: 'Download',
    dreamInterpretation: 'Dream Interpretation',
    shareYourWisdom: 'Share your cosmic wisdom',
    copied: 'Copied!',
    shareApp: 'Share App',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied!',
    copyFailed: 'Failed to copy',
    shareAppTitle: 'UNIVERSE – Ask the Universe',
    shareAppText: 'Try the UNIVERSE app for dream interpretations, tarot and daily messages',

    // Success / payment
    welcomeToUniverse: 'Welcome to the Universe!',
    youAreNowAligned: 'You are now aligned.',
    processingPayment: 'Processing Payment',
    pleaseWaitConfirm: 'Please wait while we confirm your upgrade...',
    paymentSuccessful: 'Payment Successful!',
    preparingAlignment: 'Preparing your cosmic alignment...',
    paymentFailed: 'Payment Failed',
    paymentSessionExpired: 'Your payment session has expired.',
    returnToDashboard: 'Return to Dashboard',
    checkYourEmail: 'Check Your Email',
    paymentVerificationTimeout:
      'Payment verification timed out. Please check your email for confirmation.',
    somethingWentWrong: 'Something went wrong. Please contact support.',

    // Reset password
    verifyingResetLink: 'Verifying reset link...',
    invalidResetLink: 'Invalid Reset Link',
    resetLinkExpired: 'This password reset link is invalid or has expired.',
    backToLogin: 'Back to Login',
    passwordReset: 'Password Reset!',
    redirectingToLogin: 'Redirecting to login...',
    setNewPassword: 'Set New Password',
    settingPasswordFor: 'Setting password for',
    newPassword: 'New Password',
    enterNewPassword: 'Enter new password',
    confirmPassword: 'Confirm Password',
    resetting: 'Resetting...',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordResetSuccessful: 'Password reset successful!',
    sendNewResetLink: 'Send new reset link',
    failedToResetPassword: 'Failed to reset password',

    // Account
    closeAccount: 'Close Account',
    closeAccountDescription: 'Permanently delete your account and all associated data.',
    confirmCloseAccount: 'Are you sure you want to close your account?',
    deleteAccount: 'Delete Account',
    accountDeleted: 'Account deleted successfully',
    deleteAccountTitle: 'Delete Account',
    deleteAccountDescription: 'You can permanently delete your account and all associated data.',
    deleteAccountWarning: '⚠️ This action is irreversible and cannot be undone.',
    deleteAccountConfirmTitle: 'Confirm Account Deletion',
    deleteAccountConfirmMessage:
      'Are you absolutely sure you want to delete your account? This action cannot be undone.',
    deleteAccountConfirmButton: 'Yes, delete my account',
    deleteAccountCancelButton: 'Cancel',
    deleteAccountProcessing: 'Deleting...',
    deleteAccountSuccess: 'Account deleted successfully',
    deleteAccountError: 'Failed to delete account',
    deletingAccount: 'Deleting...',
    deleteAccountFailed: 'Failed to delete account',
    accountDeleteWarning: '⚠️ This action is irreversible and cannot be undone.',
    accountDeleteIrreversible: 'Permanently delete your account and all associated data.',

    // Admin
    adminPanel: 'Admin Panel',
    totalUsers: 'Total Users',
    freeUsers: 'Free Users',
    premiumUsers: 'Premium Users',
    totalQuestions: 'Total Questions',
    users: 'Users',
    tier: 'Tier',
    admin: 'Admin',
    actions: 'Actions',
    makePremium: 'Make Premium',
    makeAdmin: 'Make Admin',
    backToDashboard: 'Back to Dashboard',

    // Footer
    footerCopyright: '©️ 2026 Universe. Cosmic wisdom for the modern seeker.',
  },

  ro: {
    // Common
    welcome: 'Bun venit',
    loading: 'Se încarcă...',
    signIn: 'Autentificare',
    signUp: 'Înregistrare',
    signOut: 'Deconectare',
    logout: 'Deconectare',
    signingIn: 'Se conectează...',
    signingUp: 'Se creează contul...',
    email: 'Email',
    password: 'Parolă',
    fullName: 'Nume complet',
    name: 'Nume',
    yes: 'Da',
    no: 'Nu',
    error: 'Eroare',
    processing: 'Se procesează...',
    cancel: 'Anulează',

    // Auth
    welcomeBack: 'Bine ai revenit',
    enterCosmicRealm: 'Intră în tărâmul cosmic',
    createAccount: 'Creează cont',
    creatingAccount: 'Se creează contul...',
    alreadyHaveAccount: 'Ai deja un cont?',
    newToUniverse: 'Nu ai cont?',
    connectWithCosmicWisdom: 'Conectează-te cu înțelepciunea cosmică',
    beginJourney: 'Începe călătoria',
    loginFailed: 'Autentificare eșuată',
    signupFailed: 'Înregistrare eșuată',
    agreePrefix: 'Sunt de acord cu',
    termsAndConditions: 'Termenii și condițiile',
    agreeSuffix: '',
    privacy: 'Confidențialitate',
    disclaimer: 'Declinare a responsabilității',
    contact: 'Contact',
    mustAcceptTerms: 'Trebuie să accepți Termenii și condițiile',

    // Landing
    enterTheUniverse: 'Intră în Univers',
    askReceiveAlign: 'Întreabă. Primește. Aliniază-te.',
    beginYourJourney: 'Începe călătoria',
    cosmicWisdom: 'Primește îndrumări mistice și înțelepciune cosmică',
    experienceCosmicConnection: 'Experimentează conexiunea cosmică',

    // Features
    mysticalWisdom: 'Înțelepciune mistică',
    mysticalWisdomDesc:
      'Primește îndrumări cosmice personalizate create din cunoștințe universale ancestrale',
    dailyMessages: 'Mesaje zilnice',
    dailyMessagesDesc: 'Începe fiecare zi cu perspective profunde din cosmos',
    premiumAccess: 'Acces Premium',
    premiumAccessDesc:
      'Întrebări nelimitate și conexiune mai profundă cu conștiința universală',

    // Free plan / pricing
    freePlan: 'Plan gratuit',
    premiumPlan: 'Premium',
    premium: 'Premium',
    oneQuestionPerDay: '1 întrebare pe zi',
    dailyCosmicMessages: 'Mesaje cosmice zilnice',
    questionHistoryFeature: 'Istoric întrebări',
    chooseYourPath: 'Alege-ți calea',
    startFree: 'Începe gratuit',
    unlockPremium: 'Deblochează Premium',
    activatePremiumAccess: 'Activează accesul Premium',
    activatePremium: 'Activează Premium',
    upgradeToPremium: 'Upgrade la Premium',
    upgradeToPremiumForMore: 'Upgrade la Premium pentru întrebări nelimitate',
    currentPlan: 'Plan',
    deepenConnection: 'Adâncește-ți conexiunea cu infinitul',
    perMonth: '/lună',
    monthly: 'Lunar',
    annual: 'Anual',
    bestValue: 'Cea mai bună ofertă',
    month: 'lună',
    year: 'an',
    billedMonthly: 'Facturat lunar',
    save17Percent: 'Economisești ~17% vs lunar',
    equivalentTo: 'Echivalent cu',
    premiumDescription: 'Adâncește-ți conexiunea cu infinitul',
    annualBillingNote: 'Facturat ca o singură plată de $59.99/an',
    fullAccessTo: 'Acces complet la:',
    cancelAnytime: 'Poți anula oricând.',
    noLongTermObligations: 'Fără obligații pe termen lung.',
    popular: 'POPULAR',

    // Premium benefits
    unlimited: 'Nelimitat',
    unlimitedQuestionsText: 'întrebări',
    deeperUniversalInsights: 'Perspective universale mai profunde',
    enhancedIntuitiveGuidance: 'Îndrumări intuitive îmbunătățite',
    personalQuestionArchive: 'Arhivă personală de întrebări',
    priorityResponseProcessing: 'Procesare prioritară a răspunsurilor',
    detailedDreamInterpretations: 'Interpretări de vise detaliate',
    personalizedTarot: 'Tarot personalizat',
    energyReadingAlignment: 'Citire energetică și aliniere',
    completeHistory: 'Istoric complet',
    aiResponsePriority: 'Prioritate la răspunsul AI',

    // Dashboard / Universe
    todaysCosmicMessage: 'Mesajul cosmic de azi',
    askTheUniverse: 'Întreabă Universul',
    askUniverse: 'Întreabă Universul',
    enterQuestion: 'Ce îndrumare cauți de la Univers?',
    consultingUniverse: 'Consult Universul...',
    theUniverseSpeaks: 'Universul vorbește',
    questionHistory: 'Istoric întrebări',
    viewQuestionHistory: 'Vezi istoricul întrebărilor',
    viewHistory: 'Vezi',
    hideHistory: 'Ascunde',
    questionsRemaining: 'întrebări rămase',
    questionsRemainingToday: 'întrebare rămasă astăzi',
    questionsRemainingTodayPlural: 'întrebări rămase astăzi',
    unlimitedQuestions: 'Întrebări nelimitate',
    dailyLimitReached: 'Limita zilnică a fost atinsă. Upgrade la Premium pentru întrebări nelimitate.',
    dailyLimitReachedWithCount:
      'Ai atins limita zilnică de {count} întrebări. Upgrade la Premium pentru acces nelimitat.',

    // Dream Portal
    dreamPortal: 'Portalul viselor',
    unlockMysteries: 'Dezvăluie misterele viselor tale',
    enterYourDreams: 'Intră în visele tale',
    dreamsAreMessages:
      'Visele sunt mesaje din subconștientul tău, șoapte din univers. Împărtășește-ți visele și primește interpretări profunde în dimensiuni simbolice, psihologice și energetice.',
    describeDream:
      'Descrie-ți visul în cât mai multe detalii îți amintești... Ce ai văzut? Ce ai simțit?',
    revealInterpretation: 'Dezvăluie interpretarea',
    interpretingDream: 'Interpretez visul tău...',
    dreamJournal: 'Jurnalul viselor',
    symbolicMeaning: 'Semnificație simbolică',
    psychologicalMeaning: 'Semnificație psihologică',
    energeticInterpretation: 'Interpretare energetică',
    yourDream: 'Visul tău:',
    hideDreamJournal: 'Ascunde jurnalul viselor',
    viewDreamJournal: 'Vezi jurnalul viselor',

    // Alignment
    dailyAlignment: 'Aliniere zilnică',
    calculatingAlignment: 'Se calculează alinierea cosmică...',
    focusOn: 'Concentrează-te pe',
    avoid: 'Evită',
    alignmentHistory: 'istoric aliniere',
    energyTheme: 'Tema energetică',

    // Tarot
    tarot: 'Tarot',
    tarotTitle: 'Trage cărțile',
    tarotDescriptionFree:
      'Primește ghidare de la o singură carte. Upgrade la Premium pentru o extragere completă de 3 cărți.',
    tarotDescriptionPremium:
      'Dezvăluie misterele Trecutului, Prezentului și Viitorului cu extragerea ta de 3 cărți.',
    singleCardDraw: 'Extragere o carte',
    threeCardSpread: 'Extragere trei cărți',
    drawCards: 'Trage cărțile',
    shuffling: 'Se amestecă pachetul...',
    tapToReveal: 'Atinge pentru a dezvălui',
    revealAll: 'Dezvăluie toate',
    yourReading: 'Citirea ta',
    past: 'Trecut',
    present: 'Prezent',
    future: 'Viitor',
    drawAgain: 'Trage din nou',
    viewTarotHistory: 'Vezi istoricul tarot',
    noTarotHistory: 'Nicio citire tarot încă.',
    dailyTarotLimit:
      'Ai tras deja cartea azi. Upgrade la Premium pentru extrageri nelimitate.',
    tarotError: 'Nu s-au putut trage cărțile. Te rugăm să încerci din nou.',
    unlockThreeCard: 'Deblochează extragerea de 3 cărți',
    threeCardBenefit: 'Obține perspective mai profunde cu citiri Trecut, Prezent și Viitor.',
    tarotCta: 'Trage cărțile și dezvăluie-ți destinul',
    premiumThreeCardActive: 'Extragere completă 3 cărți (Trecut/Prezent/Viitor) – activă',

    // Love Portal
    lovePortal: 'Portalul Iubirii',
    lovePortalDesc: "Suflete pereche, flăcări gemene, mesaje și timpul iubirii",
    lovePortalSubtitle: 'Intră în energia iubirii, a destinului, a conexiunii de suflet și a sincronizării emoționale.',
    loveSoulmateTitle: 'Citire Suflet Pereche',
    loveSoulmateDescription: 'Descoperă energia sufletului tău pereche și ce îl apropie de tine.',
    loveTwinFlameTitle: 'Citire Flacără Geamănă',
    loveTwinFlameDescription: 'Explorează separarea, energia reunificării, oglindirea și intensitatea sufletească.',
    loveMessageFromThemTitle: 'Mesaj De La Ei',
    loveMessageFromThemDescription: 'Primește un mesaj intuitiv din energia lor.',
    loveTimingTitle: 'Timpul Iubirii',
    loveTimingDescription: 'Vezi ce sincronizare emoțională se desfășoară acum în viața ta amoroasă.',
    loveYourName: 'Numele tău',
    loveYourNamePlaceholder: 'Numele tău',
    loveYourBirthDate: 'Data ta de naștere',
    loveTheirName: 'Numele persoanei',
    loveTheirNamePlaceholder: 'Numele persoanei',
    loveTheirBirthDate: 'Data de naștere a persoanei',
    loveRelationshipContext: 'Context relațional',
    loveRelationshipContextPlaceholder: 'Spune-i Portalului Iubirii ce se întâmplă între voi...',
    loveYourQuestion: 'Întrebarea ta',
    loveQuestionPlaceholder: 'Exemplu: Este această persoană flacăra mea geamănă? Ne vom reconecta? Care este energia ei acum?',
    lovePortalLoading: 'Se deschide Portalul Iubirii...',
    enterLovePortal: 'Intră în Portalul Iubirii',
    loveMainMessage: 'Mesaj principal',
    loveEnergy: 'Energie',
    loveObstacle: 'Blocaj',
    loveNextStep: 'Pasul următor',
    loveGuidance: 'Ghidare',
    loveHistory: 'Istoric Portalul Iubirii',
    loveLoadingHistory: 'Se încarcă istoricul...',
    loveNoHistory: 'Nu există încă citiri în Portalul Iubirii.',
    lovePremiumTitle: 'Portalul Iubirii Premium',
    lovePremiumDescription: 'Deblochează citiri nelimitate pentru suflet pereche, flacără geamănă, timpul iubirii și mesaje.',
    loveQuestionOrContextRequired: 'Te rog adaugă o întrebare sau un context relațional.',
    lovePortalFailed: 'Portalul Iubirii nu a putut fi deschis.',
    loveCompatibility: 'Compatibilitate',
    lovePassion: 'Atracție',
    loveCommunication: 'Comunicare',
    loveTimingScore: 'Timing',
    back: 'Înapoi',

    // Share
    share: 'Distribuie',
    copyText: 'Copiază text',
    download: 'Descarcă',
    dreamInterpretation: 'Interpretare vis',
    shareYourWisdom: 'Împărtășește înțelepciunea cosmică',
    copied: 'Copiat!',
    shareApp: 'Distribuie aplicația',
    copyLink: 'Copiază link',
    linkCopied: 'Link copiat!',
    copyFailed: 'Nu s-a putut copia',
    shareAppTitle: 'UNIVERSE – Întreabă Universul',
    shareAppText: 'Încearcă aplicația UNIVERSE pentru interpretări vise, tarot și mesaje zilnice',

    // Success / payment
    welcomeToUniverse: 'Bun venit în Universe!',
    youAreNowAligned: 'Ești acum aliniat.',
    processingPayment: 'Procesare plată',
    pleaseWaitConfirm: 'Te rugăm să aștepți confirmarea upgrade-ului...',
    paymentSuccessful: 'Plată reușită!',
    preparingAlignment: 'Pregătim alinierea ta cosmică...',
    paymentFailed: 'Plată eșuată',
    paymentSessionExpired: 'Sesiunea de plată a expirat.',
    returnToDashboard: 'Înapoi la Dashboard',
    checkYourEmail: 'Verifică emailul',
    paymentVerificationTimeout:
      'Verificarea plății a expirat. Te rugăm să verifici emailul pentru confirmare.',
    somethingWentWrong: 'Ceva nu a mers bine. Te rugăm să contactezi suportul.',

    // Reset password
    verifyingResetLink: 'Se verifică linkul de resetare...',
    invalidResetLink: 'Link de resetare invalid',
    resetLinkExpired: 'Acest link de resetare a parolei este invalid sau a expirat.',
    backToLogin: 'Înapoi la autentificare',
    passwordReset: 'Parolă resetată!',
    redirectingToLogin: 'Redirecționare către autentificare...',
    setNewPassword: 'Setează parolă nouă',
    settingPasswordFor: 'Setare parolă pentru',
    newPassword: 'Parolă nouă',
    enterNewPassword: 'Introdu parola nouă',
    confirmPassword: 'Confirmă parola',
    resetting: 'Se resetează...',
    passwordsDoNotMatch: 'Parolele nu se potrivesc',
    passwordTooShort: 'Parola trebuie să aibă minim 8 caractere',
    passwordResetSuccessful: 'Parolă resetată cu succes!',
    sendNewResetLink: 'Trimite un nou link de resetare',
    failedToResetPassword: 'Resetarea parolei a eșuat',

    // Account
    closeAccount: 'Închide cont',
    closeAccountDescription: 'Șterge permanent contul tău și toate datele asociate.',
    confirmCloseAccount: 'Ești sigur că vrei să închizi contul?',
    deleteAccount: 'Șterge contul',
    accountDeleted: 'Cont șters cu succes',
    deleteAccountTitle: 'Ștergere cont',
    deleteAccountDescription: 'Îți poți șterge definitiv contul și toate datele asociate.',
    deleteAccountWarning: '⚠️ Această acțiune este ireversibilă și nu poate fi anulată.',
    deleteAccountConfirmTitle: 'Confirmare ștergere cont',
    deleteAccountConfirmMessage:
      'Ești absolut sigur că vrei să ștergi contul? Această acțiune nu poate fi anulată.',
    deleteAccountConfirmButton: 'Da, șterge contul',
    deleteAccountCancelButton: 'Anulează',
    deleteAccountProcessing: 'Se șterge...',
    deleteAccountSuccess: 'Cont șters cu succes',
    deleteAccountError: 'Eroare la ștergerea contului.',
    deletingAccount: 'Se șterge...',
    deleteAccountFailed: 'Eroare la ștergerea contului.',
    accountDeleteWarning: '⚠️ Această acțiune este ireversibilă și nu poate fi anulată.',
    accountDeleteIrreversible: 'Șterge permanent contul tău și toate datele asociate.',

    // Admin
    adminPanel: 'Panou Admin',
    totalUsers: 'Utilizatori total',
    freeUsers: 'Utilizatori gratuiți',
    premiumUsers: 'Utilizatori Premium',
    totalQuestions: 'Întrebări total',
    users: 'Utilizatori',
    tier: 'Nivel',
    admin: 'Admin',
    actions: 'Acțiuni',
    makePremium: 'Fă Premium',
    makeAdmin: 'Fă Admin',
    backToDashboard: 'Înapoi la Dashboard',

    // Footer
    footerCopyright: '©️ 2026 Universe. Înțelepciune cosmică pentru căutătorul modern.',
  },

  es: {
    // Common
    welcome: 'Bienvenido',
    loading: 'Cargando...',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar sesión',
    logout: 'Cerrar sesión',
    signingIn: 'Iniciando sesión...',
    signingUp: 'Creando cuenta...',
    email: 'Correo electrónico',
    password: 'Contraseña',
    fullName: 'Nombre completo',
    name: 'Nombre',
    yes: 'Sí',
    no: 'No',
    error: 'Error',
    processing: 'Procesando...',
    cancel: 'Cancelar',

    // Auth
    welcomeBack: 'Bienvenido de nuevo',
    enterCosmicRealm: 'Entra en tu reino cósmico',
    createAccount: 'Crear cuenta',
    creatingAccount: 'Creando cuenta...',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    newToUniverse: '¿No tienes una cuenta?',
    connectWithCosmicWisdom: 'Conéctate con la sabiduría cósmica',
    beginJourney: 'Comienza tu viaje',
    loginFailed: 'Error de inicio de sesión',
    signupFailed: 'Error al registrarse',
    agreePrefix: 'Acepto los',
    termsAndConditions: 'Términos y condiciones',
    agreeSuffix: '',
    privacy: 'Privacidad',
    disclaimer: 'Descargo de responsabilidad',
    contact: 'Contacto',
    mustAcceptTerms: 'Debes aceptar los términos y condiciones',

    // Landing
    enterTheUniverse: 'Entra en el Universo',
    askReceiveAlign: 'Pregunta. Recibe. Alinéate.',
    beginYourJourney: 'Comienza tu viaje',
    cosmicWisdom: 'Recibe guía mística y sabiduría cósmica',
    experienceCosmicConnection: 'Experimenta la conexión cósmica',

    // Features
    mysticalWisdom: 'Sabiduría mística',
    mysticalWisdomDesc:
      'Recibe guía cósmica personalizada elaborada con conocimiento universal ancestral',
    dailyMessages: 'Mensajes diarios',
    dailyMessagesDesc: 'Comienza cada día con profundas percepciones del cosmos',
    premiumAccess: 'Acceso Premium',
    premiumAccessDesc:
      'Preguntas ilimitadas y una conexión más profunda con la conciencia universal',

    // Free plan / pricing
    freePlan: 'Plan gratuito',
    premiumPlan: 'Premium',
    premium: 'Premium',
    oneQuestionPerDay: '1 pregunta por día',
    dailyCosmicMessages: 'Mensajes cósmicos diarios',
    questionHistoryFeature: 'Historial de preguntas',
    chooseYourPath: 'Elige tu camino',
    startFree: 'Comenzar gratis',
    unlockPremium: 'Desbloquear Premium',
    activatePremiumAccess: 'Activar acceso Premium',
    activatePremium: 'Activar Premium',
    upgradeToPremium: 'Actualizar a Premium',
    upgradeToPremiumForMore: 'Actualiza a Premium para preguntas ilimitadas',
    currentPlan: 'Plan',
    deepenConnection: 'Profundiza tu conexión con el infinito',
    perMonth: '/mes',
    monthly: 'Mensual',
    annual: 'Anual',
    bestValue: 'Mejor opción',
    month: 'mes',
    year: 'año',
    billedMonthly: 'Facturado mensualmente',
    save17Percent: 'Ahorra ~17% frente al plan mensual',
    equivalentTo: 'Equivale a',
    premiumDescription: 'Profundiza tu conexión con el infinito',
    annualBillingNote: 'Facturado en un solo pago de $59.99/año',
    fullAccessTo: 'Acceso completo a:',
    cancelAnytime: 'Cancela cuando quieras.',
    noLongTermObligations: 'Sin compromisos a largo plazo.',
    popular: 'POPULAR',

    // Premium benefits
    unlimited: 'Ilimitadas',
    unlimitedQuestionsText: 'preguntas',
    deeperUniversalInsights: 'Perspectivas universales más profundas',
    enhancedIntuitiveGuidance: 'Guía intuitiva mejorada',
    personalQuestionArchive: 'Archivo personal de preguntas',
    priorityResponseProcessing: 'Procesamiento prioritario de respuestas',
    detailedDreamInterpretations: 'Interpretaciones de sueños detalladas',
    personalizedTarot: 'Tarot personalizado',
    energyReadingAlignment: 'Lectura energética y alineación',
    completeHistory: 'Historial completo',
    aiResponsePriority: 'Prioridad en la respuesta de IA',

    // Dashboard / Universe
    todaysCosmicMessage: 'Mensaje cósmico de hoy',
    askTheUniverse: 'Pregunta al Universo',
    askUniverse: 'Pregunta al Universo',
    enterQuestion: '¿Qué guía buscas del Universo?',
    consultingUniverse: 'Consultando al Universo...',
    theUniverseSpeaks: 'El Universo habla',
    questionHistory: 'Historial de preguntas',
    viewQuestionHistory: 'Ver historial de preguntas',
    viewHistory: 'Ver',
    hideHistory: 'Ocultar',
    questionsRemaining: 'preguntas restantes',
    questionsRemainingToday: 'pregunta restante hoy',
    questionsRemainingTodayPlural: 'preguntas restantes hoy',
    unlimitedQuestions: 'Preguntas ilimitadas',
    dailyLimitReached: 'Límite diario alcanzado. Actualiza a Premium para preguntas ilimitadas.',
    dailyLimitReachedWithCount:
      'Has alcanzado tu límite diario de {count} preguntas. Actualiza a Premium para acceso ilimitado.',

    // Dream Portal
    dreamPortal: 'Portal de los sueños',
    unlockMysteries: 'Descubre los misterios de tus sueños',
    enterYourDreams: 'Entra en tus sueños',
    dreamsAreMessages:
      'Los sueños son mensajes de tu subconsciente, susurros del universo. Comparte tus sueños y recibe interpretaciones profundas en dimensiones simbólicas, psicológicas y energéticas.',
    describeDream:
      'Describe tu sueño con todo el detalle que recuerdes... ¿Qué viste? ¿Qué sentiste?',
    revealInterpretation: 'Revelar interpretación',
    interpretingDream: 'Interpretando tu sueño...',
    dreamJournal: 'Diario de sueños',
    symbolicMeaning: 'Significado simbólico',
    psychologicalMeaning: 'Significado psicológico',
    energeticInterpretation: 'Interpretación energética',
    yourDream: 'Tu sueño:',
    hideDreamJournal: 'Ocultar diario de sueños',
    viewDreamJournal: 'Ver diario de sueños',

    // Alignment
    dailyAlignment: 'Alineación diaria',
    calculatingAlignment: 'Calculando tu alineación cósmica...',
    focusOn: 'Enfócate en',
    avoid: 'Evita',
    alignmentHistory: 'historial de alineación',
    energyTheme: 'Tema energético',

    // Tarot
    tarot: 'Tarot',
    tarotTitle: 'Saca tus cartas',
    tarotDescriptionFree:
      'Recibe guía de una sola carta. Actualiza a Premium para una tirada completa de 3 cartas.',
    tarotDescriptionPremium:
      'Revela los misterios del Pasado, Presente y Futuro con tu tirada de 3 cartas.',
    singleCardDraw: 'Tirada de una carta',
    threeCardSpread: 'Tirada de tres cartas',
    drawCards: 'Sacar cartas',
    shuffling: 'Barajando el mazo...',
    tapToReveal: 'Toca para revelar',
    revealAll: 'Revelar todas',
    yourReading: 'Tu lectura',
    past: 'Pasado',
    present: 'Presente',
    future: 'Futuro',
    drawAgain: 'Sacar de nuevo',
    viewTarotHistory: 'Ver historial de tarot',
    noTarotHistory: 'Aún no hay lecturas de tarot.',
    dailyTarotLimit:
      'Ya sacaste tu carta hoy. Actualiza a Premium para tiradas ilimitadas.',
    tarotError: 'No se pudieron sacar las cartas. Por favor, inténtalo de nuevo.',
    unlockThreeCard: 'Desbloquea tiradas de 3 cartas',
    threeCardBenefit:
      'Obtén perspectivas más profundas con lecturas de Pasado, Presente y Futuro.',
    tarotCta: 'Saca tus cartas y revela tu destino',
    premiumThreeCardActive: 'Tirada completa de 3 cartas (Pasado/Presente/Futuro) – activa',

    // Love Portal
    lovePortal: 'Portal del Amor',
    lovePortalSubtitle: 'Entra en la energía del amor, el destino, la conexión del alma y el tiempo emocional.',
    loveSoulmateTitle: 'Lectura de Alma Gemela',
    loveSoulmateDescription: 'Descubre la energía de tu alma gemela y qué la acerca a ti.',
    loveTwinFlameTitle: 'Lectura de Llama Gemela',
    loveTwinFlameDescription: 'Explora la separación, la energía del reencuentro, el espejo y la intensidad del alma.',
    loveMessageFromThemTitle: 'Mensaje de Su Energía',
    loveMessageFromThemDescription: 'Recibe un mensaje intuitivo desde su energía.',
    loveTimingTitle: 'Tiempo del Amor',
    loveTimingDescription: 'Descubre qué momento emocional se está desarrollando en tu vida amorosa.',
    loveYourName: 'Tu nombre',
    loveYourNamePlaceholder: 'Tu nombre',
    loveYourBirthDate: 'Tu fecha de nacimiento',
    loveTheirName: 'Su nombre',
    loveTheirNamePlaceholder: 'Su nombre',
    loveTheirBirthDate: 'Su fecha de nacimiento',
    loveRelationshipContext: 'Contexto de la relación',
    loveRelationshipContextPlaceholder: 'Cuéntale al Portal del Amor qué está pasando entre ustedes...',
    loveYourQuestion: 'Tu pregunta',
    loveQuestionPlaceholder: 'Ejemplo: ¿Es esta persona mi llama gemela? ¿Volveremos a conectar? ¿Cuál es su energía ahora?',
    lovePortalLoading: 'Abriendo el Portal del Amor...',
    enterLovePortal: 'Entrar al Portal del Amor',
    loveMainMessage: 'Mensaje principal',
    loveEnergy: 'Energía',
    loveObstacle: 'Bloqueo',
    loveNextStep: 'Próximo paso',
    loveGuidance: 'Guía',
    loveHistory: 'Historial del Portal del Amor',
    loveLoadingHistory: 'Cargando historial...',
    loveNoHistory: 'Todavía no hay lecturas en el Portal del Amor.',
    lovePremiumTitle: 'Portal del Amor Premium',
    lovePremiumDescription: 'Desbloquea lecturas ilimitadas de alma gemela, llama gemela, tiempo del amor y mensajes.',
    loveQuestionOrContextRequired: 'Por favor agrega una pregunta o un contexto de relación.',
    lovePortalFailed: 'No se pudo abrir el Portal del Amor.',
    loveCompatibility: 'Compatibilidad',
    lovePassion: 'Atracción',
    loveCommunication: 'Comunicación',
    loveTimingScore: 'Tiempo',
    back: 'Atrás',

    // Share
    share: 'Compartir',
    copyText: 'Copiar texto',
    download: 'Descargar',
    dreamInterpretation: 'Interpretación del sueño',
    shareYourWisdom: 'Comparte tu sabiduría cósmica',
    copied: '¡Copiado!',
    shareApp: 'Compartir app',
    copyLink: 'Copiar enlace',
    linkCopied: '¡Enlace copiado!',
    copyFailed: 'No se pudo copiar',
    shareAppTitle: 'UNIVERSE – Pregunta al Universo',
    shareAppText:
      'Prueba la app UNIVERSE para interpretaciones de sueños, tarot y mensajes diarios',

    // Success / payment
    welcomeToUniverse: '¡Bienvenido a Universe!',
    youAreNowAligned: 'Ahora estás alineado.',
    processingPayment: 'Procesando pago',
    pleaseWaitConfirm: 'Espera mientras confirmamos tu mejora...',
    paymentSuccessful: '¡Pago exitoso!',
    preparingAlignment: 'Preparando tu alineación cósmica...',
    paymentFailed: 'Pago fallido',
    paymentSessionExpired: 'Tu sesión de pago ha expirado.',
    returnToDashboard: 'Volver al panel',
    checkYourEmail: 'Revisa tu correo',
    paymentVerificationTimeout:
      'La verificación del pago ha expirado. Revisa tu correo para la confirmación.',
    somethingWentWrong: 'Algo salió mal. Por favor contacta con soporte.',

    // Reset password
    verifyingResetLink: 'Verificando enlace de restablecimiento...',
    invalidResetLink: 'Enlace de restablecimiento no válido',
    resetLinkExpired: 'Este enlace de restablecimiento de contraseña no es válido o ha expirado.',
    backToLogin: 'Volver al inicio de sesión',
    passwordReset: '¡Contraseña restablecida!',
    redirectingToLogin: 'Redirigiendo al inicio de sesión...',
    setNewPassword: 'Establecer nueva contraseña',
    settingPasswordFor: 'Estableciendo contraseña para',
    newPassword: 'Nueva contraseña',
    enterNewPassword: 'Introduce la nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    resetting: 'Restableciendo...',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
    passwordResetSuccessful: '¡Contraseña restablecida con éxito!',
    sendNewResetLink: 'Enviar nuevo enlace de restablecimiento',
    failedToResetPassword: 'No se pudo restablecer la contraseña',

    // Account
    closeAccount: 'Cerrar cuenta',
    closeAccountDescription: 'Elimina permanentemente tu cuenta y todos los datos asociados.',
    confirmCloseAccount: '¿Seguro que deseas cerrar tu cuenta?',
    deleteAccount: 'Eliminar cuenta',
    accountDeleted: 'Cuenta eliminada con éxito',
    deleteAccountTitle: 'Eliminar cuenta',
    deleteAccountDescription: 'Puedes eliminar permanentemente tu cuenta y todos los datos asociados.',
    deleteAccountWarning: '⚠️ Esta acción es irreversible y no se puede deshacer.',
    deleteAccountConfirmTitle: 'Confirmar eliminación de cuenta',
    deleteAccountConfirmMessage:
      '¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer.',
    deleteAccountConfirmButton: 'Sí, eliminar mi cuenta',
    deleteAccountCancelButton: 'Cancelar',
    deleteAccountProcessing: 'Eliminando...',
    deleteAccountSuccess: 'Tu cuenta ha sido eliminada permanentemente.',
    deleteAccountError: 'Error al eliminar la cuenta.',
    deletingAccount: 'Eliminando...',
    deleteAccountFailed: 'Error al eliminar la cuenta.',
    accountDeleteWarning: '⚠️ Esta acción es irreversible y no se puede deshacer.',
    accountDeleteIrreversible: 'Elimina permanentemente tu cuenta y todos los datos asociados.',

    // Admin
    adminPanel: 'Panel de administración',
    totalUsers: 'Usuarios totales',
    freeUsers: 'Usuarios gratuitos',
    premiumUsers: 'Usuarios Premium',
    totalQuestions: 'Preguntas totales',
    users: 'Usuarios',
    tier: 'Nivel',
    admin: 'Admin',
    actions: 'Acciones',
    makePremium: 'Hacer Premium',
    makeAdmin: 'Hacer Admin',
    backToDashboard: 'Volver al panel',

    // Footer
    footerCopyright: '©️ 2026 Universe. Sabiduría cósmica para el buscador moderno.',
  },

  fr: {
    // Common
    welcome: 'Bienvenue',
    loading: 'Chargement...',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    signOut: 'Se déconnecter',
    logout: 'Déconnexion',
    signingIn: 'Connexion en cours...',
    signingUp: 'Création du compte...',
    email: 'E-mail',
    password: 'Mot de passe',
    fullName: 'Nom complet',
    name: 'Nom',
    yes: 'Oui',
    no: 'Non',
    error: 'Erreur',
    processing: 'Traitement...',
    cancel: 'Annuler',

    // Auth
    welcomeBack: 'Bon retour',
    enterCosmicRealm: 'Entrez dans votre royaume cosmique',
    createAccount: 'Créer un compte',
    creatingAccount: 'Création du compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    newToUniverse: "Vous n'avez pas de compte ?",
    connectWithCosmicWisdom: 'Connectez-vous à la sagesse cosmique',
    beginJourney: 'Commencez votre voyage',
    loginFailed: 'Échec de la connexion',
    signupFailed: "Échec de l'inscription",
    agreePrefix: "J'accepte les",
    termsAndConditions: 'Conditions générales',
    agreeSuffix: '',
    privacy: 'Confidentialité',
    disclaimer: 'Clause de non-responsabilité',
    contact: 'Contact',
    mustAcceptTerms: 'Vous devez accepter les conditions générales',

    // Landing
    enterTheUniverse: "Entrer dans l'Univers",
    askReceiveAlign: 'Demandez. Recevez. Alignez-vous.',
    beginYourJourney: 'Commencez votre voyage',
    cosmicWisdom: 'Recevez des conseils mystiques et une sagesse cosmique',
    experienceCosmicConnection: 'Découvrez la connexion cosmique',

    // Features
    mysticalWisdom: 'Sagesse mystique',
    mysticalWisdomDesc:
      'Recevez des conseils cosmiques personnalisés issus du savoir universel ancestral',
    dailyMessages: 'Messages quotidiens',
    dailyMessagesDesc: 'Commencez chaque journée avec de profondes intuitions du cosmos',
    premiumAccess: 'Accès Premium',
    premiumAccessDesc:
      'Questions illimitées et connexion plus profonde avec la conscience universelle',

    // Free plan / pricing
    freePlan: 'Plan gratuit',
    premiumPlan: 'Premium',
    premium: 'Premium',
    oneQuestionPerDay: '1 question par jour',
    dailyCosmicMessages: 'Messages cosmiques quotidiens',
    questionHistoryFeature: 'Historique des questions',
    chooseYourPath: 'Choisissez votre voie',
    startFree: 'Commencer gratuitement',
    unlockPremium: 'Débloquer Premium',
    activatePremiumAccess: "Activer l'accès Premium",
    activatePremium: 'Activer Premium',
    upgradeToPremium: 'Passer à Premium',
    upgradeToPremiumForMore: 'Passez à Premium pour des questions illimitées',
    currentPlan: 'Plan',
    deepenConnection: 'Approfondissez votre connexion avec l’infini',
    perMonth: '/mois',
    monthly: 'Mensuel',
    annual: 'Annuel',
    bestValue: 'Meilleure offre',
    month: 'mois',
    year: 'an',
    billedMonthly: 'Facturé mensuellement',
    save17Percent: 'Économisez ~17% par rapport au mensuel',
    equivalentTo: 'Équivaut à',
    premiumDescription: "Approfondissez votre connexion avec l'infini",
    annualBillingNote: 'Facturé en un seul paiement de $59.99/an',
    fullAccessTo: 'Accès complet à :',
    cancelAnytime: 'Annulez à tout moment.',
    noLongTermObligations: 'Aucun engagement à long terme.',
    popular: 'POPULAIRE',

    // Premium benefits
    unlimited: 'Illimitées',
    unlimitedQuestionsText: 'questions',
    deeperUniversalInsights: 'Perspectives universelles plus profondes',
    enhancedIntuitiveGuidance: 'Guidance intuitive améliorée',
    personalQuestionArchive: 'Archive personnelle des questions',
    priorityResponseProcessing: 'Traitement prioritaire des réponses',
    detailedDreamInterpretations: 'Interprétations détaillées des rêves',
    personalizedTarot: 'Tarot personnalisé',
    energyReadingAlignment: 'Lecture énergétique et alignement',
    completeHistory: 'Historique complet',
    aiResponsePriority: "Priorité de réponse de l'IA",

    // Dashboard / Universe
    todaysCosmicMessage: "Message cosmique d'aujourd'hui",
    askTheUniverse: "Demandez à l'Univers",
    askUniverse: "Demandez à l'Univers",
    enterQuestion: "Quelle guidance recherchez-vous de l'Univers ?",
    consultingUniverse: "Consultation de l'Univers...",
    theUniverseSpeaks: "L'Univers parle",
    questionHistory: 'Historique des questions',
    viewQuestionHistory: "Voir l'historique des questions",
    viewHistory: 'Voir',
    hideHistory: 'Masquer',
    questionsRemaining: 'questions restantes',
    questionsRemainingToday: "question restante aujourd'hui",
    questionsRemainingTodayPlural: "questions restantes aujourd'hui",
    unlimitedQuestions: 'Questions illimitées',
    dailyLimitReached: 'Limite quotidienne atteinte. Passez à Premium pour des questions illimitées.',
    dailyLimitReachedWithCount:
      'Vous avez atteint votre limite quotidienne de {count} questions. Passez à Premium pour un accès illimité.',

    // Dream Portal
    dreamPortal: 'Portail des rêves',
    unlockMysteries: 'Dévoilez les mystères de vos rêves',
    enterYourDreams: 'Entrez dans vos rêves',
    dreamsAreMessages:
      "Les rêves sont des messages de votre subconscient, des murmures de l'univers. Partagez vos rêves et recevez des interprétations profondes sur les plans symbolique, psychologique et énergétique.",
    describeDream:
      'Décrivez votre rêve avec autant de détails que possible... Qu’avez-vous vu ? Qu’avez-vous ressenti ?',
    revealInterpretation: "Révéler l'interprétation",
    interpretingDream: 'Interprétation de votre rêve...',
    dreamJournal: 'Journal des rêves',
    symbolicMeaning: 'Signification symbolique',
    psychologicalMeaning: 'Signification psychologique',
    energeticInterpretation: 'Interprétation énergétique',
    yourDream: 'Votre rêve :',
    hideDreamJournal: 'Masquer le journal des rêves',
    viewDreamJournal: 'Voir le journal des rêves',

    // Alignment
    dailyAlignment: 'Alignement quotidien',
    calculatingAlignment: 'Calcul de votre alignement cosmique...',
    focusOn: 'Concentrez-vous sur',
    avoid: 'Évitez',
    alignmentHistory: "historique d'alignement",
    energyTheme: 'Thème énergétique',

    // Tarot
    tarot: 'Tarot',
    tarotTitle: 'Tirez vos cartes',
    tarotDescriptionFree:
      'Recevez des conseils grâce à un tirage d’une seule carte. Passez à Premium pour un tirage complet de 3 cartes.',
    tarotDescriptionPremium:
      'Révélez les mystères du Passé, du Présent et du Futur avec votre tirage de 3 cartes.',
    singleCardDraw: 'Tirage d’une carte',
    threeCardSpread: 'Tirage de trois cartes',
    drawCards: 'Tirer les cartes',
    shuffling: 'Mélange du jeu...',
    tapToReveal: 'Touchez pour révéler',
    revealAll: 'Tout révéler',
    yourReading: 'Votre lecture',
    past: 'Passé',
    present: 'Présent',
    future: 'Futur',
    drawAgain: 'Tirer à nouveau',
    viewTarotHistory: "Voir l'historique du tarot",
    noTarotHistory: 'Aucune lecture de tarot pour le moment.',
    dailyTarotLimit:
      'Vous avez déjà tiré votre carte aujourd’hui. Passez à Premium pour des tirages illimités.',
    tarotError: "Impossible de tirer les cartes. Veuillez réessayer.",
    unlockThreeCard: 'Débloquer les tirages à 3 cartes',
    threeCardBenefit:
      'Obtenez des perspectives plus profondes avec les lectures Passé, Présent et Futur.',
    tarotCta: 'Tirez vos cartes et révélez votre destin',
    premiumThreeCardActive: 'Tirage complet de 3 cartes (Passé/Présent/Futur) – actif',

    // Love Portal
    lovePortal: "Portail de l'Amour",
    lovePortalSubtitle: "Entrez dans l’énergie de l’amour, du destin, de la connexion d’âme et du timing émotionnel.",
    loveSoulmateTitle: 'Lecture Âme Sœur',
    loveSoulmateDescription: 'Découvrez l’énergie de votre âme sœur et ce qui la rapproche de vous.',
    loveTwinFlameTitle: 'Lecture Flamme Jumelle',
    loveTwinFlameDescription: 'Explorez la séparation, l’énergie de réunion, le miroir et l’intensité de l’âme.',
    loveMessageFromThemTitle: 'Message de Leur Énergie',
    loveMessageFromThemDescription: 'Recevez un message intuitif depuis leur énergie.',
    loveTimingTitle: "Timing de l'Amour",
    loveTimingDescription: "Découvrez quel timing émotionnel se déploie dans votre vie amoureuse.",
    loveYourName: 'Votre nom',
    loveYourNamePlaceholder: 'Votre nom',
    loveYourBirthDate: 'Votre date de naissance',
    loveTheirName: 'Son nom',
    loveTheirNamePlaceholder: 'Son nom',
    loveTheirBirthDate: 'Sa date de naissance',
    loveRelationshipContext: 'Contexte relationnel',
    loveRelationshipContextPlaceholder: "Dites au Portail de l'Amour ce qui se passe entre vous...",
    loveYourQuestion: 'Votre question',
    loveQuestionPlaceholder: 'Exemple : Cette personne est-elle ma flamme jumelle ? Allons-nous nous retrouver ? Quelle est son énergie en ce moment ?',
    lovePortalLoading: "Ouverture du Portail de l'Amour...",
    enterLovePortal: "Entrer dans le Portail de l'Amour",
    loveMainMessage: 'Message principal',
    loveEnergy: 'Énergie',
    loveObstacle: 'Blocage',
    loveNextStep: 'Prochaine étape',
    loveGuidance: 'Guidance',
    loveHistory: "Historique du Portail de l'Amour",
    loveLoadingHistory: "Chargement de l'historique...",
    loveNoHistory: "Aucune lecture du Portail de l'Amour pour le moment.",
    lovePremiumTitle: "Portail de l'Amour Premium",
    lovePremiumDescription: "Débloquez des lectures illimitées d’âme sœur, de flamme jumelle, de timing amoureux et de messages.",
    loveQuestionOrContextRequired: 'Veuillez ajouter une question ou un contexte relationnel.',
    lovePortalFailed: "Impossible d’ouvrir le Portail de l'Amour.",
    loveCompatibility: 'Compatibilité',
    lovePassion: 'Attraction',
    loveCommunication: 'Communication',
    loveTimingScore: 'Timing',
    back: 'Retour',

    // Share
    share: 'Partager',
    copyText: 'Copier le texte',
    download: 'Télécharger',
    dreamInterpretation: 'Interprétation du rêve',
    shareYourWisdom: 'Partagez votre sagesse cosmique',
    copied: 'Copié !',
    shareApp: "Partager l'application",
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié !',
    copyFailed: 'Échec de la copie',
    shareAppTitle: "UNIVERSE – Demandez à l'Univers",
    shareAppText:
      "Essayez l'application UNIVERSE pour les interprétations de rêves, le tarot et les messages quotidiens",

    // Success / payment
    welcomeToUniverse: 'Bienvenue dans Universe !',
    youAreNowAligned: 'Vous êtes maintenant aligné.',
    processingPayment: 'Traitement du paiement',
    pleaseWaitConfirm: 'Veuillez patienter pendant que nous confirmons votre mise à niveau...',
    paymentSuccessful: 'Paiement réussi !',
    preparingAlignment: 'Préparation de votre alignement cosmique...',
    paymentFailed: 'Paiement échoué',
    paymentSessionExpired: 'Votre session de paiement a expiré.',
    returnToDashboard: 'Retour au tableau de bord',
    checkYourEmail: 'Vérifiez votre e-mail',
    paymentVerificationTimeout:
      'La vérification du paiement a expiré. Veuillez consulter votre e-mail pour confirmation.',
    somethingWentWrong: "Un problème s'est produit. Veuillez contacter le support.",

    // Reset password
    verifyingResetLink: 'Vérification du lien de réinitialisation...',
    invalidResetLink: 'Lien de réinitialisation invalide',
    resetLinkExpired: 'Ce lien de réinitialisation du mot de passe est invalide ou a expiré.',
    backToLogin: 'Retour à la connexion',
    passwordReset: 'Mot de passe réinitialisé !',
    redirectingToLogin: 'Redirection vers la connexion...',
    setNewPassword: 'Définir un nouveau mot de passe',
    settingPasswordFor: 'Définition du mot de passe pour',
    newPassword: 'Nouveau mot de passe',
    enterNewPassword: 'Entrez le nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    resetting: 'Réinitialisation...',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères',
    passwordResetSuccessful: 'Mot de passe réinitialisé avec succès !',
    sendNewResetLink: 'Envoyer un nouveau lien de réinitialisation',
    failedToResetPassword: 'Échec de la réinitialisation du mot de passe',

    // Account
    closeAccount: 'Fermer le compte',
    closeAccountDescription:
      'Supprimez définitivement votre compte et toutes les données associées.',
    confirmCloseAccount: 'Êtes-vous sûr de vouloir fermer votre compte ?',
    deleteAccount: 'Supprimer le compte',
    accountDeleted: 'Compte supprimé avec succès',
    deleteAccountTitle: 'Supprimer le compte',
    deleteAccountDescription:
      'Vous pouvez supprimer définitivement votre compte et toutes les données associées.',
    deleteAccountWarning: '⚠️ Cette action est irréversible et ne peut pas être annulée.',
    deleteAccountConfirmTitle: 'Confirmer la suppression du compte',
    deleteAccountConfirmMessage:
      'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
    deleteAccountConfirmButton: 'Oui, supprimer mon compte',
    deleteAccountCancelButton: 'Annuler',
    deleteAccountProcessing: 'Suppression...',
    deleteAccountSuccess: 'Votre compte a été supprimé définitivement.',
    deleteAccountError: 'Erreur lors de la suppression du compte.',
    deletingAccount: 'Suppression...',
    deleteAccountFailed: 'Erreur lors de la suppression du compte.',
    accountDeleteWarning: '⚠️ Cette action est irréversible et ne peut pas être annulée.',
    accountDeleteIrreversible:
      'Supprimez définitivement votre compte et toutes les données associées.',

    // Admin
    adminPanel: "Panneau d'administration",
    totalUsers: 'Utilisateurs totaux',
    freeUsers: 'Utilisateurs gratuits',
    premiumUsers: 'Utilisateurs Premium',
    totalQuestions: 'Questions totales',
    users: 'Utilisateurs',
    tier: 'Niveau',
    admin: 'Admin',
    actions: 'Actions',
    makePremium: 'Passer en Premium',
    makeAdmin: 'Rendre Admin',
    backToDashboard: 'Retour au tableau de bord',

    // Footer
    footerCopyright: '©️ 2026 Universe. Sagesse cosmique pour le chercheur moderne.',
  },

  de: {
    // Common
    welcome: 'Willkommen',
    loading: 'Wird geladen...',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signOut: 'Abmelden',
    logout: 'Abmelden',
    signingIn: 'Anmeldung läuft...',
    signingUp: 'Konto wird erstellt...',
    email: 'E-Mail',
    password: 'Passwort',
    fullName: 'Vollständiger Name',
    name: 'Name',
    yes: 'Ja',
    no: 'Nein',
    error: 'Fehler',
    processing: 'Wird verarbeitet...',
    cancel: 'Abbrechen',

    // Auth
    welcomeBack: 'Willkommen zurück',
    enterCosmicRealm: 'Betritt dein kosmisches Reich',
    createAccount: 'Konto erstellen',
    creatingAccount: 'Konto wird erstellt...',
    alreadyHaveAccount: 'Hast du bereits ein Konto?',
    newToUniverse: 'Hast du noch kein Konto?',
    connectWithCosmicWisdom: 'Verbinde dich mit kosmischer Weisheit',
    beginJourney: 'Beginne deine Reise',
    loginFailed: 'Anmeldung fehlgeschlagen',
    signupFailed: 'Registrierung fehlgeschlagen',
    agreePrefix: 'Ich stimme den',
    termsAndConditions: 'Allgemeinen Geschäftsbedingungen',
    agreeSuffix: ' zu',
    privacy: 'Datenschutz',
    disclaimer: 'Haftungsausschluss',
    contact: 'Kontakt',
    mustAcceptTerms: 'Du musst die Allgemeinen Geschäftsbedingungen akzeptieren',

    // Landing
    enterTheUniverse: 'Betritt das Universum',
    askReceiveAlign: 'Frage. Empfange. Richte dich aus.',
    beginYourJourney: 'Beginne deine Reise',
    cosmicWisdom: 'Erhalte mystische Führung und kosmische Weisheit',
    experienceCosmicConnection: 'Erlebe kosmische Verbindung',

    // Features
    mysticalWisdom: 'Mystische Weisheit',
    mysticalWisdomDesc:
      'Erhalte personalisierte kosmische Führung aus uraltem universellem Wissen',
    dailyMessages: 'Tägliche Botschaften',
    dailyMessagesDesc: 'Beginne jeden Tag mit tiefen Einsichten aus dem Kosmos',
    premiumAccess: 'Premium-Zugang',
    premiumAccessDesc:
      'Unbegrenzte Fragen und eine tiefere Verbindung zum universellen Bewusstsein',

    // Free plan / pricing
    freePlan: 'Kostenloser Plan',
    premiumPlan: 'Premium',
    premium: 'Premium',
    oneQuestionPerDay: '1 Frage pro Tag',
    dailyCosmicMessages: 'Tägliche kosmische Botschaften',
    questionHistoryFeature: 'Fragenverlauf',
    chooseYourPath: 'Wähle deinen Weg',
    startFree: 'Kostenlos starten',
    unlockPremium: 'Premium freischalten',
    activatePremiumAccess: 'Premium-Zugang aktivieren',
    activatePremium: 'Premium aktivieren',
    upgradeToPremium: 'Zu Premium wechseln',
    upgradeToPremiumForMore: 'Wechsle zu Premium für unbegrenzte Fragen',
    currentPlan: 'Plan',
    deepenConnection: 'Vertiefe deine Verbindung mit dem Unendlichen',
    perMonth: '/Monat',
    monthly: 'Monatlich',
    annual: 'Jährlich',
    bestValue: 'Bestes Angebot',
    month: 'Monat',
    year: 'Jahr',
    billedMonthly: 'Monatlich abgerechnet',
    save17Percent: 'Spare ~17% gegenüber monatlich',
    equivalentTo: 'Entspricht',
    premiumDescription: 'Vertiefe deine Verbindung mit dem Unendlichen',
    annualBillingNote: 'Abgerechnet als einmalige Zahlung von $59.99/Jahr',
    fullAccessTo: 'Voller Zugriff auf:',
    cancelAnytime: 'Jederzeit kündbar.',
    noLongTermObligations: 'Keine langfristigen Verpflichtungen.',
    popular: 'BELIEBT',

    // Premium benefits
    unlimited: 'Unbegrenzt',
    unlimitedQuestionsText: 'Fragen',
    deeperUniversalInsights: 'Tiefere universelle Einsichten',
    enhancedIntuitiveGuidance: 'Verbesserte intuitive Führung',
    personalQuestionArchive: 'Persönliches Fragenarchiv',
    priorityResponseProcessing: 'Priorisierte Antwortverarbeitung',
    detailedDreamInterpretations: 'Detaillierte Traumdeutungen',
    personalizedTarot: 'Personalisiertes Tarot',
    energyReadingAlignment: 'Energielesung & Ausrichtung',
    completeHistory: 'Vollständiger Verlauf',
    aiResponsePriority: 'Priorität bei KI-Antworten',

    // Dashboard / Universe
    todaysCosmicMessage: 'Heutige kosmische Botschaft',
    askTheUniverse: 'Frage das Universum',
    askUniverse: 'Frage das Universum',
    enterQuestion: 'Welche Führung suchst du vom Universum?',
    consultingUniverse: 'Das Universum wird befragt...',
    theUniverseSpeaks: 'Das Universum spricht',
    questionHistory: 'Fragenverlauf',
    viewQuestionHistory: 'Fragenverlauf ansehen',
    viewHistory: 'Ansehen',
    hideHistory: 'Ausblenden',
    questionsRemaining: 'verbleibende Fragen',
    questionsRemainingToday: 'verbleibende Frage heute',
    questionsRemainingTodayPlural: 'verbleibende Fragen heute',
    unlimitedQuestions: 'Unbegrenzte Fragen',
    dailyLimitReached:
      'Tägliches Limit erreicht. Wechsle zu Premium für unbegrenzte Fragen.',
    dailyLimitReachedWithCount:
      'Du hast dein tägliches Limit von {count} Fragen erreicht. Wechsle zu Premium für unbegrenzten Zugriff.',

    // Dream Portal
    dreamPortal: 'Traumportal',
    unlockMysteries: 'Enthülle die Geheimnisse deiner Träume',
    enterYourDreams: 'Betritt deine Träume',
    dreamsAreMessages:
      'Träume sind Botschaften deines Unterbewusstseins, Flüstern des Universums. Teile deine Träume und erhalte tiefgründige Deutungen in symbolischen, psychologischen und energetischen Dimensionen.',
    describeDream:
      'Beschreibe deinen Traum so detailliert, wie du dich erinnerst... Was hast du gesehen? Was hast du gefühlt?',
    revealInterpretation: 'Deutung enthüllen',
    interpretingDream: 'Dein Traum wird gedeutet...',
    dreamJournal: 'Traumtagebuch',
    symbolicMeaning: 'Symbolische Bedeutung',
    psychologicalMeaning: 'Psychologische Bedeutung',
    energeticInterpretation: 'Energetische Interpretation',
    yourDream: 'Dein Traum:',
    hideDreamJournal: 'Traumtagebuch ausblenden',
    viewDreamJournal: 'Traumtagebuch ansehen',

    // Alignment
    dailyAlignment: 'Tägliche Ausrichtung',
    calculatingAlignment: 'Deine kosmische Ausrichtung wird berechnet...',
    focusOn: 'Konzentriere dich auf',
    avoid: 'Vermeide',
    alignmentHistory: 'Ausrichtungsverlauf',
    energyTheme: 'Energiethema',

    // Tarot
    tarot: 'Tarot',
    tarotTitle: 'Ziehe deine Karten',
    tarotDescriptionFree:
      'Erhalte Führung durch eine einzelne Karte. Wechsle zu Premium für ein vollständiges 3-Karten-Legesystem.',
    tarotDescriptionPremium:
      'Enthülle die Geheimnisse von Vergangenheit, Gegenwart und Zukunft mit deinem 3-Karten-Legesystem.',
    singleCardDraw: 'Eine Karte ziehen',
    threeCardSpread: 'Drei-Karten-Legung',
    drawCards: 'Karten ziehen',
    shuffling: 'Das Deck wird gemischt...',
    tapToReveal: 'Zum Aufdecken tippen',
    revealAll: 'Alle Karten aufdecken',
    yourReading: 'Deine Legung',
    past: 'Vergangenheit',
    present: 'Gegenwart',
    future: 'Zukunft',
    drawAgain: 'Erneut ziehen',
    viewTarotHistory: 'Tarotverlauf ansehen',
    noTarotHistory: 'Noch keine Tarot-Lesungen.',
    dailyTarotLimit:
      'Du hast heute bereits deine Karte gezogen. Wechsle zu Premium für unbegrenzte Ziehungen.',
    tarotError: 'Die Karten konnten nicht gezogen werden. Bitte versuche es erneut.',
    unlockThreeCard: '3-Karten-Legung freischalten',
    threeCardBenefit:
      'Erhalte tiefere Einsichten mit Legungen für Vergangenheit, Gegenwart und Zukunft.',
    tarotCta: 'Ziehe deine Karten und enthülle dein Schicksal',
    premiumThreeCardActive:
      'Vollständige 3-Karten-Legung (Vergangenheit/Gegenwart/Zukunft) – aktiv',

    // Love Portal
    lovePortal: 'Love Portal',
    lovePortalSubtitle: 'Betritt die Energie von Liebe, Schicksal, Seelenverbindung und emotionalem Timing.',
    loveSoulmateTitle: 'Seelenpartner-Lesung',
    loveSoulmateDescription: 'Entdecke die Energie deines Seelenpartners und was ihn näher zu dir zieht.',
    loveTwinFlameTitle: 'Zwillingsflammen-Lesung',
    loveTwinFlameDescription: 'Erkunde Trennung, Wiedervereinigungsenergie, Spiegelung und seelische Intensität.',
    loveMessageFromThemTitle: 'Botschaft Von Ihrer Energie',
    loveMessageFromThemDescription: 'Empfange eine intuitive Botschaft aus ihrer Energie.',
    loveTimingTitle: 'Timing der Liebe',
    loveTimingDescription: 'Sieh, welches emotionale Timing sich in deinem Liebesweg entfaltet.',
    loveYourName: 'Dein Name',
    loveYourNamePlaceholder: 'Dein Name',
    loveYourBirthDate: 'Dein Geburtsdatum',
    loveTheirName: 'Name der Person',
    loveTheirNamePlaceholder: 'Name der Person',
    loveTheirBirthDate: 'Geburtsdatum der Person',
    loveRelationshipContext: 'Beziehungskontext',
    loveRelationshipContextPlaceholder: 'Erzähle dem Love Portal, was zwischen euch geschieht...',
    loveYourQuestion: 'Deine Frage',
    loveQuestionPlaceholder: 'Beispiel: Ist diese Person meine Zwillingsflamme? Werden wir uns wieder verbinden? Wie ist ihre Energie gerade?',
    lovePortalLoading: 'Love Portal wird geöffnet...',
    enterLovePortal: 'Betritt das Love Portal',
    loveMainMessage: 'Hauptbotschaft',
    loveEnergy: 'Energie',
    loveObstacle: 'Blockade',
    loveNextStep: 'Nächster Schritt',
    loveGuidance: 'Führung',
    loveHistory: 'Love-Portal-Verlauf',
    loveLoadingHistory: 'Verlauf wird geladen...',
    loveNoHistory: 'Noch keine Love-Portal-Lesungen.',
    lovePremiumTitle: 'Premium Love Portal',
    lovePremiumDescription: 'Schalte unbegrenzte Seelenpartner-, Zwillingsflammen-, Liebes-Timing- und Nachrichten-Lesungen frei.',
    loveQuestionOrContextRequired: 'Bitte füge eine Frage oder einen Beziehungskontext hinzu.',
    lovePortalFailed: 'Love Portal konnte nicht geöffnet werden.',
    loveCompatibility: 'Kompatibilität',
    lovePassion: 'Anziehung',
    loveCommunication: 'Kommunikation',
    loveTimingScore: 'Timing',
    back: 'Zurück',

    // Share
    share: 'Teilen',
    copyText: 'Text kopieren',
    download: 'Herunterladen',
    dreamInterpretation: 'Traumdeutung',
    shareYourWisdom: 'Teile deine kosmische Weisheit',
    copied: 'Kopiert!',
    shareApp: 'App teilen',
    copyLink: 'Link kopieren',
    linkCopied: 'Link kopiert!',
    copyFailed: 'Kopieren fehlgeschlagen',
    shareAppTitle: 'UNIVERSE – Frage das Universum',
    shareAppText:
      'Probiere die UNIVERSE-App für Traumdeutungen, Tarot und tägliche Botschaften',

    // Success / payment
    welcomeToUniverse: 'Willkommen bei Universe!',
    youAreNowAligned: 'Du bist jetzt ausgerichtet.',
    processingPayment: 'Zahlung wird verarbeitet',
    pleaseWaitConfirm: 'Bitte warte, während wir dein Upgrade bestätigen...',
    paymentSuccessful: 'Zahlung erfolgreich!',
    preparingAlignment: 'Deine kosmische Ausrichtung wird vorbereitet...',
    paymentFailed: 'Zahlung fehlgeschlagen',
    paymentSessionExpired: 'Deine Zahlungssitzung ist abgelaufen.',
    returnToDashboard: 'Zurück zum Dashboard',
    checkYourEmail: 'Prüfe deine E-Mails',
    paymentVerificationTimeout:
      'Die Zahlungsbestätigung ist abgelaufen. Bitte prüfe deine E-Mails zur Bestätigung.',
    somethingWentWrong: 'Etwas ist schiefgelaufen. Bitte kontaktiere den Support.',

    // Reset password
    verifyingResetLink: 'Zurücksetzungslink wird überprüft...',
    invalidResetLink: 'Ungültiger Zurücksetzungslink',
    resetLinkExpired:
      'Dieser Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.',
    backToLogin: 'Zurück zur Anmeldung',
    passwordReset: 'Passwort zurückgesetzt!',
    redirectingToLogin: 'Weiterleitung zur Anmeldung...',
    setNewPassword: 'Neues Passwort festlegen',
    settingPasswordFor: 'Passwort wird festgelegt für',
    newPassword: 'Neues Passwort',
    enterNewPassword: 'Neues Passwort eingeben',
    confirmPassword: 'Passwort bestätigen',
    resetting: 'Wird zurückgesetzt...',
    passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    passwordResetSuccessful: 'Passwort erfolgreich zurückgesetzt!',
    sendNewResetLink: 'Neuen Zurücksetzungslink senden',
    failedToResetPassword: 'Passwort konnte nicht zurückgesetzt werden',

    // Account
    closeAccount: 'Konto schließen',
    closeAccountDescription: 'Lösche dein Konto und alle zugehörigen Daten dauerhaft.',
    confirmCloseAccount: 'Bist du sicher, dass du dein Konto schließen möchtest?',
    deleteAccount: 'Konto löschen',
    accountDeleted: 'Konto erfolgreich gelöscht',
    deleteAccountTitle: 'Konto löschen',
    deleteAccountDescription:
      'Du kannst dein Konto und alle zugehörigen Daten dauerhaft löschen.',
    deleteAccountWarning:
      '⚠️ Diese Aktion ist unwiderruflich und kann nicht rückgängig gemacht werden.',
    deleteAccountConfirmTitle: 'Kontolöschung bestätigen',
    deleteAccountConfirmMessage:
      'Bist du sicher, dass du dein Konto löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteAccountConfirmButton: 'Ja, Konto löschen',
    deleteAccountCancelButton: 'Abbrechen',
    deleteAccountProcessing: 'Wird gelöscht...',
    deleteAccountSuccess: 'Dein Konto wurde dauerhaft gelöscht.',
    deleteAccountError: 'Fehler beim Löschen des Kontos.',
    deletingAccount: 'Wird gelöscht...',
    deleteAccountFailed: 'Fehler beim Löschen des Kontos.',
    accountDeleteWarning:
      '⚠️ Diese Aktion ist unwiderruflich und kann nicht rückgängig gemacht werden.',
    accountDeleteIrreversible:
      'Lösche dein Konto und alle zugehörigen Daten dauerhaft.',

    // Admin
    adminPanel: 'Admin-Bereich',
    totalUsers: 'Gesamte Nutzer',
    freeUsers: 'Kostenlose Nutzer',
    premiumUsers: 'Premium-Nutzer',
    totalQuestions: 'Gesamte Fragen',
    users: 'Nutzer',
    tier: 'Stufe',
    admin: 'Admin',
    actions: 'Aktionen',
    makePremium: 'Zu Premium machen',
    makeAdmin: 'Zum Admin machen',
    backToDashboard: 'Zurück zum Dashboard',

    // Footer
    footerCopyright:
      '©️ 2026 Universe. Kosmische Weisheit für den modernen Suchenden.',
  },
};

const DEFAULT_LANGUAGE = 'en';

export const useTranslation = (language) => {
  const safeLanguage = translations[language] ? language : DEFAULT_LANGUAGE;

  const t = (key, params = {}) => {
    const found =
      translations[safeLanguage]?.[key] ??
      translations[DEFAULT_LANGUAGE]?.[key];

    if (!found) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`Missing translation key: ${key} (${safeLanguage})`);
      }
      return `__${key}__`;
    }

    let text = String(found);

    Object.keys(params).forEach((param) => {
      text = text.replace(`{${param}}`, String(params[param]));
    });

    return text;
  };

  return { t };
};
